import styled from 'styled-components/macro';

export const ProgramItemListStyled = styled.div`
  ${({ theme: { spacing } }) => `
    display: flex;
    flex-wrap: wrap;
    & > span {
      margin-right: ${spacing?.(1)};
    }
  `};
`;

export const InputWrapperStyled = styled.div`
  ${({ theme: { spacing } }) => `
    &:first-of-type {
      margin-top: ${spacing?.(4)};
    }
  `};
`;

export const ConfirmationWrapperStyled = styled.div`
  ${({ theme: { typography, spacing } }) => `
    ${typography?.(18)}
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    & div {
      margin-top: ${spacing?.(4)};
    }
  `}
`;
